import { handleError } from 'shared/api/lib/errors/handlers'

import { SERVICE_WORKER_LOCATION } from './constants'

export function register() {
  const swUrl = `${window.origin}${SERVICE_WORKER_LOCATION}`
  const isNotDev =
    window.origin === 'https://app.manychat.io' || window.origin === 'https://manychat.com'

  if ('serviceWorker' in navigator && isNotDev) {
    navigator.serviceWorker.register(swUrl).catch((error) => {
      handleError(error)
    })
  }
}
